import { X, MessageCircle } from "lucide-react";
import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

const WhatsAppFormModal = ({ isOpen, onClose }) => {
  const { t, lang } = useLanguage();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  if (!isOpen) return null;

  const esFormUrl = "https://links.thefunnelbox.com/widget/form/HPsflnZriTUwVr9RUcbD";
  const enFormUrl = "https://links.thefunnelbox.com/widget/form/exRhTOYCcadnBJX720ST";
  const formUrl = lang === "es" ? esFormUrl : enFormUrl;
  const formId = lang === "es" ? "HPsflnZriTUwVr9RUcbD" : "exRhTOYCcadnBJX720ST";
  const formName = lang === "es" ? "ESPAÑOL Form WSP | Landing page Google Ads" : "English Form WSP | Landing page Google Ads";

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="whatsapp-form-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white w-full max-w-md shadow-2xl animate-fade-in-up max-h-[90vh] flex flex-col">
        {/* Green header with WhatsApp icon */}
        <div className="bg-[#25D366] px-6 py-4 flex items-center gap-4 flex-shrink-0">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <MessageCircle className="w-6 h-6 text-white fill-white" />
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-lg text-white">{t.whatsappModal.title}</h3>
            <p className="text-white/80 text-sm">{t.whatsappModal.subtitle}</p>
          </div>
          <button onClick={onClose} data-testid="whatsapp-modal-close" className="w-8 h-8 flex items-center justify-center text-white/80 hover:text-white transition-colors flex-shrink-0">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form iframe - clean, no offset */}
        <div className="flex-1 overflow-y-auto" style={{ height: "600px" }}>
          <iframe
            key={lang}
            src={formUrl}
            style={{ width: "100%", height: "100%", border: "none" }}
            id={`inline-${formId}`}
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name={formName}
            data-height="600"
            data-layout-iframe-id={`inline-${formId}`}
            data-form-id={formId}
            title={formName}
          />
        </div>
      </div>
    </div>
  );
};

export default WhatsAppFormModal;
